import { render, staticRenderFns } from "./BaseError.vue?vue&type=template&id=76db07f4&"
import script from "./BaseError.vue?vue&type=script&lang=js&"
export * from "./BaseError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76db07f4')) {
      api.createRecord('76db07f4', component.options)
    } else {
      api.reload('76db07f4', component.options)
    }
    module.hot.accept("./BaseError.vue?vue&type=template&id=76db07f4&", function () {
      api.rerender('76db07f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/errors/screens/BaseError.vue"
export default component.exports